"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M0 1v6h7V0H1C.45 0 0 .45 0 1zm0 14c0 .55.45 1 1 1h6V9H0v6zM15 0H9v7h7V1c0-.55-.45-1-1-1zM9 16h6c.55 0 1-.45 1-1V9H9v7z"];
//# sourceMappingURL=grid-view.js.map